<template>
    <div v-bind="containerProps" :class="iconInfoClass">
        <common-icon :name="icon" :size="size"></common-icon>

        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            icon: { type: String, required: true },
            size: { type: String, required: true },
            href: { type: String, default: null },
        },

        computed: {
            iconInfoClass() {
                return {
                    'icon-info': true,
                    [`icon-info--size-${this.size}`]: true,
                }
            },

            containerProps() {
                if (this.href) {
                    return {
                        is: 'a',
                        href: this.href,
                    }
                }

                return {
                    is: 'div',
                }
            },
        },
    }
</script>
